import { render, staticRenderFns } from "./NextIcon.vue?vue&type=template&id=3cbf882e&scoped=true&"
import script from "./NextIcon.vue?vue&type=script&lang=ts&"
export * from "./NextIcon.vue?vue&type=script&lang=ts&"
import style0 from "./NextIcon.vue?vue&type=style&index=0&id=3cbf882e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbf882e",
  null
  
)

export default component.exports